import { FC } from 'react'
import { ForgotPasswordTemplate } from '../templates'

export const ForgotPasswordPage: FC = () => {
  return (
    <ForgotPasswordTemplate />
  )
}